exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resize {\r\n  width: 250px;\r\n  height: 200px;\r\n}\r\n\r\n.nav-justified {\r\n   border-collapse:separate;\r\n   border-spacing:5px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/sara/epicodus/quasi-etsy/src/app/category/category.component.css
// module id = ../../../../../src/app/category/category.component.css
// module chunks = main